import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { TablePdf } from "../TablePdf/TablePdf";
import { TableHeader as TableHeaderPDF } from "@david.kucsai/react-pdf-table/lib/TableHeader";
import { TableCell as TableCellPDF } from "@david.kucsai/react-pdf-table/lib/TableCell";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import { DataTableCell } from "@david.kucsai/react-pdf-table";
import GetCurrency from "../../helper/GetCurrency";

export default function ViewArticlesExtended(props) {
  let totalCount = 0;
  let totalAmount = 0;

  let articles = props.articles;

  let data = [];
  Object.keys(articles).forEach((plu) => {
    Object.keys(articles[plu]).forEach((name) => {
      Object.keys(articles[plu][name]).forEach((price) => {
        let article = articles[plu][name][price];
        totalCount += article["amount_paid"];
        totalAmount += price * article["amount_paid"];
        data.push({
          plu: plu,
          name: name,
          price: GetCurrency() + (price / 100.0).toFixed(2),
          numberPaid: article["amount_paid"],
          amountPaid: GetCurrency() + ((price * article["amount_paid"]) / 100.0).toFixed(2),
        });
      });
    });
  });

  let plus = {};
  data.forEach((row) => {
    if (plus[row.plu] == null) {
      plus[row.plu] = [];
    }
    plus[row.plu].push(row);
  });
  Object.keys(plus).forEach((plu) => {
    plus[plu] = plus[plu].sort((a, b) => {
      if (a.numberPaid < b.numberPaid) {
        return 1;
      } else if (a.numberPaid > b.numberPaid) {
        return -1;
      } else {
        return 0;
      }
    });
  });

  let pluSorted = Object.keys(plus).sort((a, b) => {
    let numberPaidA = plus[a].reduce((r, k) => {
      return r + k.numberPaid;
    }, 0);
    let numberPaidB = plus[b].reduce((r, k) => {
      return r + k.numberPaid;
    }, 0);
    if (numberPaidA < numberPaidB) {
      return 1;
    } else if (numberPaidA > numberPaidB) {
      return -1;
    } else {
      return 0;
    }
  });

  plus = pluSorted.map((plu) => {
    return plus[plu];
  });

  data = plus.reduce((r, k) => {
    return r.concat(k);
  }, []);

  const getPdfView = () => {
    return (
      <TablePdf data={data}>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Article code</TableCellPDF>
          <TableCellPDF weighting={0.3}>Article name</TableCellPDF>
          <TableCellPDF weighting={0.3}>Article price</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Aantal verkocht
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Bedrag verkocht
          </TableCellPDF>
        </TableHeaderPDF>
        <TableBodyPDF>
          <DataTableCell weighting={0.3} getContent={(r) => r.plu} />
          <DataTableCell weighting={0.3} getContent={(r) => r.name} />
          <DataTableCell weighting={0.3} getContent={(r) => r.price} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r.numberPaid} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r.amountPaid} />
        </TableBodyPDF>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Totaal</TableCellPDF>
          <TableCellPDF weighting={0.3} />
          <TableCellPDF weighting={0.3} />
          <TableCellPDF weighting={0.3} align={"right"}>
            {totalCount}
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {GetCurrency() + (totalAmount / 100.0).toFixed(2)}
          </TableCellPDF>
        </TableHeaderPDF>
      </TablePdf>
    );
  };

  props.createPdf(getPdfView());
  //
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Article code</TableCell>
            <TableCell>Article name</TableCell>
            <TableCell>Article price</TableCell>
            <TableCell align={"right"}>Aantal verkocht</TableCell>
            <TableCell align={"right"}>Bedrag verkocht</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((r) => {
            return (
              <TableRow>
                <TableCell>{r.plu}</TableCell>
                <TableCell>{r.name}</TableCell>
                <TableCell>{r.price}</TableCell>
                <TableCell align={"right"}>{r.numberPaid}</TableCell>
                <TableCell align={"right"}>{r.amountPaid}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell>Totaal</TableCell>
            <TableCell />
            <TableCell />
            <TableCell align={"right"}>{totalCount}</TableCell>
            <TableCell align={"right"}>
              {GetCurrency()} {(totalAmount / 100.0).toFixed(2)}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
